export interface GetPriceListPagingAndFilterResponse {
    isSuccess: boolean
    message: any
    data: GetPriceListPagingAndFilterResponseData
}

export interface GetPriceListPagingAndFilterResponseData {
    items: GetPriceListPagingAndFilterResponseItem[]
    totalRecordCount: number
}

export interface GetPriceListPagingAndFilterResponseItem {
    priceId: string
    companyId: string
    refNo: string
    name: string
    isOpenArea: boolean
    isClosedArea: boolean
    isHeatControllerRoom: boolean
    isCustomActive: boolean
    startDate: string
    endDate: string
    productKindId: string
    potTypeId: string
    heatControlDetailId: string
    serviceId: string
    multiplier1Id: string
    multiplier2Id: string
    unitPrice?: number
    currencyTypeId: string
    minPrice?: number
    productKindName: string
    potTypeName: string
    heatControlDetailName?: string
    serviceName: string
    multiplier1Name: string
    multiplier2Name: string
    currencyTypeName: string
    createdDate: string
    createdUser: string
    updatedDate: string
    updatedUser: string
    isSelected: boolean
}

export const initialGetPriceListPagingAndFilterResponseData: GetPriceListPagingAndFilterResponseData = {
    items: [],
    totalRecordCount: 0
}